import { fetcherWithToken } from '@/shared/api/fetcher';
import useSWR from 'swr';
import useSWRMutation from 'swr/mutation';
import { useIsAuth } from '@/shared/providers/user-provider/use-user';

async function claimRewards(url) {
  // const params = new URLSearchParams({ level: arg });
  return fetcherWithToken(`${url}`, {
    method: 'GET',
  });
}

const useCashback = () => {
  const isAuth = useIsAuth();
  const { data, isLoading, mutate } = useSWR(
    isAuth ? '/cashback/get' : null,
    fetcherWithToken
  );
  const { trigger: claimRewardsTrigger,isMutating: isClaimingLoading  } = useSWRMutation(
    '/cashback/claim',
    claimRewards
  );
  
  return {
    data,
    isLoading,
    claimRewardsTrigger,
    mutate,
    isClaimingLoading
  };
};

const useCashbackHistory = () => {
  const { data, isLoading } = useSWR('/cashback/history', fetcherWithToken);
  return {
    data,
    isLoading,
  };
};

export { useCashback, useCashbackHistory };
